import React, {Fragment} from "react";
import {FormControlLabel, Grid, Typography} from "@mui/material";
import {FastField, getIn, useFormikContext} from "formik";
import {FullWidthText} from "./index";
import HiddenDependentField from "./HiddenDependentField";
import {sprintf} from "sprintf-js";
import {ManagedSwitch} from "./ManagedSwitch";

const now = new Date();
const hidden = "hidden";

const validateComment = (value) => {
    if (!!value && value.length > 52) {
        return "Must be 52 characters or less";
    }
    return "";
}

const LeadChecklistField = ({...props}) => {
    const {values, setFieldValue} = useFormikContext();
    const year = new Date(getIn(values, "a.yearConstructed")).getFullYear();
    const [approvalDateName, didPassName, commentName] = [
        sprintf("%s.approvalDate", props.rank),
        sprintf("%s.didPass", props.rank),
        sprintf("%s.comment", props.rank)
    ];
    const [approvalDefault, didPassDefault, commentDefault] = [
        getIn(values, approvalDateName),
        getIn(values, didPassName),
        getIn(values, commentName)
    ];
    const isLeadQuestion = props.desc.startsWith("Lead-Based Paint");
    const hideLeadQuestion = (!Object.is(NaN, year) && (year > 1977));

    //Hide any Lead paint questions if the building was constructed in 1978 or later.
    //Fill out the fields anyway so things are unambiguous.
    React.useEffect(() => {
        if (isLeadQuestion) {
            if (hideLeadQuestion) {
                setFieldValue(approvalDateName, now);
                setFieldValue(didPassName, true);
                setFieldValue(commentName, "Building constructed after December 31st, 1977.");
            } else {
                setFieldValue(approvalDateName, approvalDefault);
                setFieldValue(didPassName, didPassDefault);
                setFieldValue(commentName, commentDefault);
            }
        }
    }, [
        approvalDateName, approvalDefault, commentName, commentDefault, didPassName, didPassDefault,
        hideLeadQuestion, isLeadQuestion, setFieldValue
    ]);
    if (isLeadQuestion && hideLeadQuestion) {
        return (
            <Fragment>
                <Grid item xs={12} sm={12}>
                    <Typography variant={"subtitle2"} gutterBottom>
                        <del>{sprintf("%s %s", props.rank, props.desc)}</del>
                        {"NOT APPLICABLE"}
                    </Typography>
                    <br/>
                </Grid>
                <Grid container spacing={3}>
                    <FastField
                        name={approvalDateName}
                        type={hidden}
                    />
                    <FastField
                        name={didPassName}
                        type={hidden}
                    />
                    <FastField
                        name={commentName}
                        type={hidden}
                    />
                </Grid>
            </Fragment>
        );
    }
    return (ChecklistField(props));
};

const ChecklistField = ({...props}) => {
    const [approvalDateName, didPassName, commentName] = [
        sprintf("%s.approvalDate", props.rank),
        sprintf("%s.didPass", props.rank),
        sprintf("%s.comment", props.rank)
    ];

    return (
        <>
            <Grid item xs={12} sm={12}>
                <Typography variant={"subtitle2"} gutterBottom>
                    {sprintf("%s %s", props.rank, props.desc)}
                </Typography>
            </Grid>
            <HiddenDependentField
                name={approvalDateName}
                dependency={didPassName}
                /*Using new Date() here will lead to re-rendering every ms!*/
                newvalue={now}
            />
            <Grid item xs={3} sm={3}>
                <FormControlLabel control={<ManagedSwitch name={didPassName}/>}
                                  label={"Pass"}
                />
            </Grid>
            <Grid item xs={12} sm={8}>
                <FullWidthText
                    name={commentName}
                    label={"Comment"}
                    fast={true}
                    spellCheck={true}
                    validate={validateComment}
                />
            </Grid>
        </>
    );
};

export {ChecklistField, LeadChecklistField};